import Request from "./Request";

const PdfCoRequest = {
  convertImageToPdf(url) {
    const formData = new FormData();
    formData.append("url", url);

    return Request().post(`/pdf/convert/from/image`, formData);
  },

  getPreSignedUrl(params) {
    return Request().get("/file/upload/get-presigned-url", params);
  },

  getPreSignedUrlFromBase64(params) {
    return Request().post("/file/upload/base64", params);
  },

  getPDFFieldsInfo(params) {
    return Request().post("/pdf/info/fields", params);
  },

  fillPdfForm(params) {
    return Request().post("/pdf/edit/add", params);
  },

  putFileFromUrl(url, data, options = {}) {
    return Request().custom({
      method: "PUT",
      url,
      data,
      ...options,
    });
  },

  checkIfJobIsCompleted(data) {
    return Request().post("/job/check", data);
  },
};

export default PdfCoRequest;
